"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[561],{

/***/ 19838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bz": function() { return /* binding */ ALLOWED_PRICE_IMPACT_LOW; },
/* harmony export */   "EV": function() { return /* binding */ PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN; },
/* harmony export */   "IP": function() { return /* binding */ CUSTOM_BASES; },
/* harmony export */   "IS": function() { return /* binding */ ONE_BIPS; },
/* harmony export */   "PM": function() { return /* binding */ BIPS_BASE; },
/* harmony export */   "Ru": function() { return /* binding */ BETTER_TRADE_LESS_HOPS_THRESHOLD; },
/* harmony export */   "TY": function() { return /* binding */ BIG_INT_TEN; },
/* harmony export */   "Uf": function() { return /* binding */ ALLOWED_PRICE_IMPACT_HIGH; },
/* harmony export */   "Uz": function() { return /* binding */ MIN_BNB; },
/* harmony export */   "VN": function() { return /* binding */ DEFAULT_INPUT_CURRENCY; },
/* harmony export */   "Zw": function() { return /* binding */ INPUT_FRACTION_AFTER_FEE; },
/* harmony export */   "bR": function() { return /* binding */ ROUTER_ADDRESS; },
/* harmony export */   "ck": function() { return /* binding */ ADDITIONAL_BASES; },
/* harmony export */   "fI": function() { return /* binding */ ZERO_PERCENT; },
/* harmony export */   "g$": function() { return /* binding */ DEFAULT_OUTPUT_CURRENCY; },
/* harmony export */   "iV": function() { return /* binding */ BIG_INT_ZERO; },
/* harmony export */   "kx": function() { return /* binding */ SUGGESTED_BASES; },
/* harmony export */   "lM": function() { return /* binding */ BASES_TO_CHECK_TRADES_AGAINST; },
/* harmony export */   "lN": function() { return /* binding */ BLOCKED_PRICE_IMPACT_NON_EXPERT; },
/* harmony export */   "p9": function() { return /* binding */ ALLOWED_PRICE_IMPACT_MEDIUM; },
/* harmony export */   "q3": function() { return /* binding */ GENERIC_GAS_LIMIT_ORDER_EXECUTION; },
/* harmony export */   "uX": function() { return /* binding */ GELATO_HANDLER; },
/* harmony export */   "vm": function() { return /* binding */ LIMIT_ORDERS_DOCS_URL; },
/* harmony export */   "yC": function() { return /* binding */ ONE_HUNDRED_PERCENT; }
/* harmony export */ });
/* unused harmony exports BASES_TO_TRACK_LIQUIDITY_FOR, PINNED_PAIRS, BASE_FEE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54346);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2593);
/* harmony import */ var _tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29748);




var _obj;
var ROUTER_ADDRESS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC, "0x10ED43C718714eb63d5aA57B78B54704E256024E"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET, "0xD99D1c33F9fC3444f8101754aBC46c52416550D1"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.PULSE */ .a_.PULSE, "0x165C3410fC91EF562C50559f7d2289fEbed552d9"), _obj);
var _obj1;
// used to construct intermediary pairs for trading
var BASES_TO_CHECK_TRADES_AGAINST = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC, [
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.wbnb */ .ds.wbnb,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.cake */ .ds.cake,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.busd */ .ds.busd,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.usdt */ .ds.usdt,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.btcb */ .ds.btcb,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.eth */ .ds.eth,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.usdc */ .ds.usdc, 
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET, [
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.wbnb */ .dI.wbnb,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.cake */ .dI.cake,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.busd */ .dI.busd
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.PULSE */ .a_.PULSE, []), _obj1);
/**
 * Additional bases for specific tokens
 * @example { [WBTC.address]: [renBTC], [renBTC.address]: [WBTC] }
 */ var ADDITIONAL_BASES = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC, {});
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 * @example [AMPL.address]: [DAI, WNATIVE[ChainId.BSC]]
 */ var CUSTOM_BASES = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC, {});
var _obj2;
// used for display in the default list when adding liquidity
var SUGGESTED_BASES = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC, [
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.busd */ .ds.busd,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.cake */ .ds.cake,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.btcb */ .ds.btcb
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET, [
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.wbnb */ .dI.wbnb,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.cake */ .dI.cake,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.busd */ .dI.busd
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.PULSE */ .a_.PULSE, []), _obj2);
var _obj3;
// used to construct the list of all pairs we consider by default in the frontend
var BASES_TO_TRACK_LIQUIDITY_FOR = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC, [
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.wbnb */ .ds.wbnb,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.dai */ .ds.dai,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.busd */ .ds.busd,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.usdt */ .ds.usdt
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET, [
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.wbnb */ .dI.wbnb,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.cake */ .dI.cake,
    _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTestnetTokens.busd */ .dI.busd
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.PULSE */ .a_.PULSE, []), _obj3);
var PINNED_PAIRS = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .ChainId.BSC */ .a_.BSC, [
    [
        _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.cake */ .ds.cake,
        _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.wbnb */ .ds.wbnb
    ],
    [
        _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.busd */ .ds.busd,
        _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.usdt */ .ds.usdt
    ],
    [
        _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.dai */ .ds.dai,
        _tokens__WEBPACK_IMPORTED_MODULE_1__/* .bscTokens.usdt */ .ds.usdt
    ], 
]);
var BIG_INT_ZERO = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(0);
var BIG_INT_TEN = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(10);
// one basis point
var BIPS_BASE = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(10000);
var ONE_BIPS = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(1), BIPS_BASE);
// used for warning states
var ALLOWED_PRICE_IMPACT_LOW = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(100), BIPS_BASE) // 1%
;
var ALLOWED_PRICE_IMPACT_MEDIUM = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(300), BIPS_BASE) // 3%
;
var ALLOWED_PRICE_IMPACT_HIGH = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(500), BIPS_BASE) // 5%
;
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
var PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(1000), BIPS_BASE) // 10%
;
// for non expert mode disable swaps above this
var BLOCKED_PRICE_IMPACT_NON_EXPERT = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(1500), BIPS_BASE) // 15%
;
// used to ensure the user doesn't send so much BNB so they end up with <.01
var MIN_BNB = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.exponentiate */ .QA.exponentiate(BIG_INT_TEN, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(16)) // .01 BNB
;
var BETTER_TRADE_LESS_HOPS_THRESHOLD = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(50), BIPS_BASE);
var ZERO_PERCENT = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG("0");
var ONE_HUNDRED_PERCENT = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG("1");
var BASE_FEE = new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Percent */ .gG(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(25), BIPS_BASE);
var INPUT_FRACTION_AFTER_FEE = ONE_HUNDRED_PERCENT.subtract(BASE_FEE);
// BNB
var DEFAULT_INPUT_CURRENCY = "PLS";
// MINTX
var DEFAULT_OUTPUT_CURRENCY = "0x207e6b4529840A4fd518f73c68bc9c19B2A15944";
// Handler string is passed to Gelato to use PCS router
var GELATO_HANDLER = "pancakeswap";
var GENERIC_GAS_LIMIT_ORDER_EXECUTION = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_3__/* .BigNumber.from */ .O$.from(500000);
var LIMIT_ORDERS_DOCS_URL = "https://docs.pancakeswap.finance/products/pancakeswap-exchange/limit-orders";


/***/ }),

/***/ 23715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mP": function() { return /* binding */ useIsTransactionUnsupported; },
  "uK": function() { return /* binding */ useIsTransactionWarning; },
  "AU": function() { return /* binding */ useTradeExactIn; },
  "in": function() { return /* binding */ useTradeExactOut; }
});

// UNUSED EXPORTS: useAllCommonPairs

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
;// CONCATENATED MODULE: ./src/utils/trades.ts


// returns whether tradeB is better than tradeA by at least a threshold percentage amount
function isTradeBetter(tradeA, tradeB) {
    var minimumDelta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : exchange/* ZERO_PERCENT */.fI;
    if (tradeA && !tradeB) return false;
    if (tradeB && !tradeA) return true;
    if (!tradeA || !tradeB) return undefined;
    if (tradeA.tradeType !== tradeB.tradeType || !(0,src/* currencyEquals */.KA)(tradeA.inputAmount.currency, tradeB.inputAmount.currency) || !(0,src/* currencyEquals */.KA)(tradeA.outputAmount.currency, tradeB.outputAmount.currency)) {
        throw new Error("Trades are not comparable");
    }
    if (minimumDelta.equalTo(exchange/* ZERO_PERCENT */.fI)) {
        return tradeA.executionPrice.lessThan(tradeB.executionPrice);
    }
    return tradeA.executionPrice.raw.multiply(minimumDelta.add(exchange/* ONE_HUNDRED_PERCENT */.yC)).lessThan(tradeB.executionPrice);
}
/* harmony default export */ var trades = ((/* unused pure expression or super */ null && (isTradeBetter)));

// EXTERNAL MODULE: ./node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(94654);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(84915);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(53854);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(86435);
;// CONCATENATED MODULE: ./src/hooks/Trades.ts


/* eslint-disable no-param-reassign */ 









function useAllCommonPairs(currencyA, currencyB) {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,_sliced_to_array/* default */.Z)(chainId ? [
        (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId),
        (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)
    ] : [
        undefined,
        undefined
    ], 2), tokenA = ref[0], tokenB = ref[1];
    var bases = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!chainId) return [];
        var _chainId;
        var common = (_chainId = exchange/* BASES_TO_CHECK_TRADES_AGAINST */.lM[chainId]) !== null && _chainId !== void 0 ? _chainId : [];
        var ref2;
        var additionalA = tokenA ? (ref2 = (ref = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref === void 0 ? void 0 : ref[tokenA.address]) !== null && ref2 !== void 0 ? ref2 : [] : [];
        var ref3;
        var additionalB = tokenB ? (ref3 = (ref1 = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref1 === void 0 ? void 0 : ref1[tokenB.address]) !== null && ref3 !== void 0 ? ref3 : [] : [];
        return (0,_to_consumable_array/* default */.Z)(common).concat((0,_to_consumable_array/* default */.Z)(additionalA), (0,_to_consumable_array/* default */.Z)(additionalB));
    }, [
        chainId,
        tokenA,
        tokenB
    ]);
    var basePairs = (0,react.useMemo)(function() {
        return flatMap_default()(bases, function(base) {
            return bases.map(function(otherBase) {
                return [
                    base,
                    otherBase
                ];
            });
        });
    }, [
        bases
    ]);
    var allPairCombinations = (0,react.useMemo)(function() {
        return tokenA && tokenB ? [
            // the direct pair
            [
                tokenA,
                tokenB
            ], 
        ].concat(// token A against all bases
        (0,_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenA,
                base
            ];
        })), // token B against all bases
        (0,_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenB,
                base
            ];
        })), // each base against all bases
        (0,_to_consumable_array/* default */.Z)(basePairs)).filter(function(tokens) {
            return Boolean(tokens[0] && tokens[1]);
        }).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), t0 = _param[0], t1 = _param[1];
            return t0.address !== t1.address;
        }).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tokenA_ = _param[0], tokenB_ = _param[1];
            if (!chainId) return true;
            var customBases = exchange/* CUSTOM_BASES */.IP[chainId];
            var customBasesA = customBases === null || customBases === void 0 ? void 0 : customBases[tokenA_.address];
            var customBasesB = customBases === null || customBases === void 0 ? void 0 : customBases[tokenB_.address];
            if (!customBasesA && !customBasesB) return true;
            if (customBasesA && !customBasesA.find(function(base) {
                return tokenB_.equals(base);
            })) return false;
            if (customBasesB && !customBasesB.find(function(base) {
                return tokenA_.equals(base);
            })) return false;
            return true;
        }) : [];
    }, [
        tokenA,
        tokenB,
        bases,
        basePairs,
        chainId
    ]);
    var allPairs = (0,usePairs/* usePairs */.z$)(allPairCombinations);
    // only pass along valid pairs, non-duplicated pairs
    return (0,react.useMemo)(function() {
        return Object.values(allPairs// filter out invalid pairs
        .filter(function(result) {
            return Boolean(result[0] === usePairs/* PairState.EXISTS */._G.EXISTS && result[1]);
        })// filter out duplicated pairs
        .reduce(function(memo, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), curr = _param[1];
            var _address;
            memo[curr.liquidityToken.address] = (_address = memo[curr.liquidityToken.address]) !== null && _address !== void 0 ? _address : curr;
            return memo;
        }, {}));
    }, [
        allPairs
    ]);
}
var MAX_HOPS = 3;
/**
 * Returns the best trade for the exact amount of tokens in to the given token out
 */ function useTradeExactIn(currencyAmountIn, currencyOut) {
    var allowedPairs = useAllCommonPairs(currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : currencyAmountIn.currency, currencyOut);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyAmountIn && currencyOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                // if current trade is best yet, save it
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        allowedPairs,
        currencyAmountIn,
        currencyOut,
        singleHopOnly
    ]);
}
/**
 * Returns the best trade for the token in to the exact amount of token out
 */ function useTradeExactOut(currencyIn, currencyAmountOut) {
    var allowedPairs = useAllCommonPairs(currencyIn, currencyAmountOut === null || currencyAmountOut === void 0 ? void 0 : currencyAmountOut.currency);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyIn && currencyAmountOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        currencyIn,
        currencyAmountOut,
        allowedPairs,
        singleHopOnly
    ]);
}
function useIsTransactionUnsupported(currencyIn, currencyOut) {
    var unsupportedTokens = (0,Tokens/* useUnsupportedTokens */.l6)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var tokenIn = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyIn, chainId);
    var tokenOut = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}
function useIsTransactionWarning(currencyIn, currencyOut) {
    var unsupportedTokens = (0,Tokens/* useWarningTokens */.zd)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var tokenIn = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyIn, chainId);
    var tokenOut = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 60872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uc": function() { return /* binding */ calculateSlippageAmount; },
  "b5": function() { return /* binding */ computeSlippageAdjustedAmounts; },
  "U7": function() { return /* binding */ computeTradePriceBreakdown; },
  "Kh": function() { return /* binding */ formatExecutionPrice; },
  "iY": function() { return /* binding */ getRouterContract; },
  "oX": function() { return /* binding */ warningSeverity; }
});

// UNUSED EXPORTS: basisPointsToPercent

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
;// CONCATENATED MODULE: ./src/config/abi/IPancakeRouter02.json
var IPancakeRouter02_namespaceObject = JSON.parse('[{"inputs":[],"name":"WETH","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"amountADesired","type":"uint256"},{"internalType":"uint256","name":"amountBDesired","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountTokenDesired","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountIn","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountOut","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsIn","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsOut","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"reserveA","type":"uint256"},{"internalType":"uint256","name":"reserveB","type":"uint256"}],"name":"quote","outputs":[{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETHSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermit","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermitSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityWithPermit","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapETHForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETHSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"}]');
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
;// CONCATENATED MODULE: ./src/utils/exchange.ts







// converts a basis points value to a sdk percent
function basisPointsToPercent(num) {
    return new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(num), exchange/* BIPS_BASE */.PM);
}
function calculateSlippageAmount(value, slippage) {
    if (slippage < 0 || slippage > 10000) {
        throw Error("Unexpected slippage value: ".concat(slippage));
    }
    return [
        src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(value.raw, src/* JSBI.BigInt */.QA.BigInt(10000 - slippage)), exchange/* BIPS_BASE */.PM),
        src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(value.raw, src/* JSBI.BigInt */.QA.BigInt(10000 + slippage)), exchange/* BIPS_BASE */.PM), 
    ];
}
// account is optional
function getRouterContract(chainId, library, account) {
    return (0,utils/* getContract */.uN)(exchange/* ROUTER_ADDRESS */.bR[chainId], IPancakeRouter02_namespaceObject, (0,utils/* getProviderOrSigner */.TY)(library, account));
}
// computes price breakdown for the trade
function computeTradePriceBreakdown(trade) {
    // for each hop in our trade, take away the x*y=k price impact from 0.3% fees
    // e.g. for 3 tokens/2 hops: 1 - ((1 - .03) * (1-.03))
    var realizedLPFee = !trade ? undefined : exchange/* ONE_HUNDRED_PERCENT.subtract */.yC.subtract(trade.route.pairs.reduce(function(currentFee) {
        return currentFee.multiply(exchange/* INPUT_FRACTION_AFTER_FEE */.Zw);
    }, exchange/* ONE_HUNDRED_PERCENT */.yC));
    // remove lp fees from price impact
    var priceImpactWithoutFeeFraction = trade && realizedLPFee ? trade.priceImpact.subtract(realizedLPFee) : undefined;
    // the x*y=k impact
    var priceImpactWithoutFeePercent = priceImpactWithoutFeeFraction ? new src/* Percent */.gG(priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.numerator, priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.denominator) : undefined;
    // the amount of the input that accrues to LPs
    var realizedLPFeeAmount = realizedLPFee && trade && ((0,_instanceof/* default */.Z)(trade.inputAmount, src/* TokenAmount */.dt) ? new src/* TokenAmount */.dt(trade.inputAmount.token, realizedLPFee.multiply(trade.inputAmount.raw).quotient) : src/* CurrencyAmount.ether */.ih.ether(realizedLPFee.multiply(trade.inputAmount.raw).quotient));
    return {
        priceImpactWithoutFee: priceImpactWithoutFeePercent,
        realizedLPFee: realizedLPFeeAmount
    };
}
// computes the minimum amount out and maximum amount in for a trade given a user specified allowed slippage in bips
function computeSlippageAdjustedAmounts(trade, allowedSlippage) {
    var pct = basisPointsToPercent(allowedSlippage);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, trade === null || trade === void 0 ? void 0 : trade.maximumAmountIn(pct)), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(pct)), _obj;
}
function warningSeverity(priceImpact) {
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* BLOCKED_PRICE_IMPACT_NON_EXPERT */.lN))) return 4;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_HIGH */.Uf))) return 3;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_MEDIUM */.p9))) return 2;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_LOW */.Bz))) return 1;
    return 0;
}
function formatExecutionPrice(trade, inverted) {
    if (!trade) {
        return "";
    }
    return inverted ? "".concat(trade.executionPrice.invert().toSignificant(6), " ").concat(trade.inputAmount.currency.symbol, " / ").concat(trade.outputAmount.currency.symbol) : "".concat(trade.executionPrice.toSignificant(6), " ").concat(trade.outputAmount.currency.symbol, " / ").concat(trade.inputAmount.currency.symbol);
}


/***/ }),

/***/ 97938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61744);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54346);



// try to parse a user entered amount for a given token
var tryParseAmount = function(value, currency) {
    if (!value || !currency) {
        return undefined;
    }
    try {
        var typedValueParsed = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_1__/* .parseUnits */ .vz)(value, currency.decimals).toString();
        if (typedValueParsed !== "0") {
            return (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU) ? new _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .TokenAmount */ .dt(currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(typedValueParsed)) : _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.ether */ .ih.ether(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(typedValueParsed));
        }
    } catch (error) {
        // should fail if the user specifies too many decimal places of precision (or maybe exceed max uint?)
        console.debug('Failed to parse input amount: "'.concat(value, '"'), error);
    }
    // necessary for all paths to return a value
    return undefined;
};
/* harmony default export */ __webpack_exports__["Z"] = (tryParseAmount);


/***/ })

}]);